module.exports = __webpack_public_path__ + "img/buy-car600x338.cb27858e.png";